<div class="content-wrapper container-xxl p-0">
  <div class="content-body">
    <div class="row match-height justify-content-center">
      <div class="col-xl-9 col-md-9 col-12" *ngIf="siteSettings?.globalSettings?.site_notify !== ''">
        <div class="alert alert-info alert-dismissible fade show p-1" role="alert">
          <div [innerHTML]="siteSettings?.globalSettings?.site_notify"></div>
          <button type="button" class="close" aria-label="Close" (click)="dismissAlert()">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
      </div>
    </div>
    <div class="row match-height">
      <!-- Medal Card -->
      <div class="col-xl-4 col-md-6 col-12" *ngIf="data?.wallet?.status == 1">
        <div class="card card-congratulation-medal">
          <div class="card-body">
            <h5>Hello, {{ user?.name }}!</h5>
            <p class="card-text font-small-3">{{ data!.wallet!.balance_card!.title }} | <small>ID: <b>{{ data!.wallet!.balance_card!.walletID }}</b></small></p>
            <h3 class="mb-75 mt-2 pt-50">
              <a href="javascript:void(0);">{{ data!.wallet!.balance_card!.balance | currency: "₦" }}</a>
            </h3>
            <button (click)="topupWallet()" type="button" class="btn btn-primary" rippleEffect>Top-up Wallet</button>
            <img src="assets/images/illustration/badge.svg" class="congratulation-medal" alt="Medal Pic" />
          </div>
        </div>
      </div>
      <!--/ Medal Card -->

      <!-- Statistics Card -->
      <div class="col-xl-8 col-md-6 col-12">
        <div class="card card-statistics">
          <div class="card-header">
            <h4 class="card-title">Statistics</h4>
            <div class="d-flex align-items-center">
              <p class="card-text font-small-2 mr-25 mb-0">{{ data.updated_at }}</p>
            </div>
          </div>
          <div class="card-body statistics-body">
            <div class="row">
              <div class="col-sm-6 col-xl-4 mb-2 mb-xl-0">
                <div class="media">
                  <div class="avatar bg-light-primary mr-2">
                    <div class="avatar-content">
                      <svg xmlns="http://www.w3.org/2000/svg" class="avatar-icon icon icon-tabler icon-tabler-currency-naira" width="44" height="44" viewBox="0 0 24 24" stroke-width="1.5" stroke="#2c3e50" fill="none" stroke-linecap="round" stroke-linejoin="round">
                        <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                        <path d="M7 18v-10.948a1.05 1.05 0 0 1 1.968 -.51l6.064 10.916a1.05 1.05 0 0 0 1.968 -.51v-10.948" />
                        <path d="M5 10h14" />
                        <path d="M5 14h14" />
                      </svg>
                    </div>
                  </div>
                  <div class="media-body my-auto">
                    <h4 class="font-weight-bolder mb-0">{{ data?.wallet?.spent_total?.amount | currency: "₦" }}</h4>
                    <p class="card-text font-small-3 mb-0">Spent</p>
                  </div>
                </div>
              </div>
              <div class="col-sm-6 col-xl-4 mb-2 mb-xl-0">
                <div class="media">
                  <div class="avatar bg-light-info mr-2">
                    <div class="avatar-content">
                      <i data-feather="user" class="avatar-icon"></i>
                    </div>
                  </div>
                  <div class="media-body my-auto">
                    <h4 class="font-weight-bolder mb-0">{{ data?.wallet?.funding_total?.amount | currency: "₦" }}</h4>
                    <p class="card-text font-small-3 mb-0">Funded</p>
                  </div>
                </div>
              </div>
              <div class="col-sm-6 col-xl-4 mb-2 mb-sm-0" *ngIf="data?.wallet?.balance_card?.cashback_status == 'on'">
                <div class="media">
                  <div class="avatar bg-light-danger mr-2">
                    <div class="avatar-content">
                      <i data-feather="box" class="avatar-icon"></i>
                    </div>
                  </div>
                  <div class="media-body my-auto">
                    <h4 class="font-weight-bolder mb-0">{{ data?.wallet?.balance_card?.cashback_balance | currency: "₦" }}</h4>
                    <p class="card-text font-small-3 mb-0">Cashback</p>
                  </div>
                </div>
              </div>
              <div class="col-sm-6 col-xl-4 d-none" *ngIf="data?.referral?.status === 1">
                <div class="media">
                  <div class="avatar bg-light-success mr-2">
                    <div class="avatar-content">
                      <i data-feather="wallet" class="avatar-icon"></i>
                    </div>
                  </div>
                  <div class="media-body my-auto">
                    <h4 class="font-weight-bolder mb-0">{{ data?.referral.balance | currency: "₦" }}</h4>
                    <p class="card-text font-small-3 mb-0">Bonus</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--/ Statistics Card -->
    </div>

     <!--<div class="col-md-12 col-12">
        <div class="card">
          <div class="card-body pb-50">
            <ngb-alert [type]="'info'" [dismissible]="false">
              <div class="alert-body">
                Newly Registered? Choose a Membership Plan NOW to start using our services. <span style="color: red;">(Required)</span>
                <div><p></p>
                  <button (click)="upgradeMembership()" type="button" class="btn btn-primary" rippleEffect>Upgrade Account</button>
                </div>
              </div>
            </ngb-alert>
          </div>
        </div>
      </div> -->


    <!-- Virtual Accounts -->
<div class="row justify-content-center mt-1" *ngIf="data!.virtual_accounts.length > 0">
  <div class="col-md-12">
    <p *ngIf="user.cbn_verified === 0" class="text-center">Virtual Accounts: Transfer money into any below to fund your wallet. <a href="/account/fundwallet">Kindly Click Here to Verify BVN/NIN</a></p>
    <p *ngIf="user.cbn_verified === 1" class="text-center">Virtual Accounts: Transfer money into any below to fund your wallet.</p>
  </div>

  <!-- Iterate over virtual accounts and display in two columns -->
  <div class="col-6" *ngFor="let item of data!.virtual_accounts">
    <!--<div class="card mb-4 virtual-account-card" *ngIf="item.accountNumber !==''">
      <div class="card-body">
        <h4 class="card-title mb-1">{{ item.bankName }}</h4>
        <div class="account-number">{{ item.accountNumber }}</div>
        <h5 class="mb-1">{{ item.accountName }}</h5>
      </div>
    </div>-->
  </div>
</div>


    <div class="row match-height" *ngIf="isAdmin">
      
      <div class="col-lg-8 col-12">
        <!-- Revenue Report Card -->
        <div class="card card-revenue-budget">
          <div class="row mx-0 mt-2">
            <div class="col-lg-12">
              <div class="minibuttons">
                <div class="mbutton" *ngFor="let item of services" (click)="goPage(item)">
                  <p class="title">{{ item.name }}</p>
                </div>
              </div>

              <!-- <div class="container">
                <div class="row">
                  <div class="col-3" *ngFor="let item of services" (click)="goPage(item)">
                    <a href="#" class="text-decoration-none pt-0 px-2 text-center w-100">
                      <div class="relative d-flex flex-column text-break bg-gradient w-100 shadow rounded overflow-hidden">
                        <div class="px-2 py-2 flex-auto">
                          <div class="text-white text-center d-flex mx-auto justify-content-center align-items-center">
                            <div class="w-100 text-center max-h-10 overflow-hidden">
                              <img src="http://localhost:5173/src/assets/img/services/nairabet.png" alt="NairaBet" class="w-100 h-100 object-fill mx-auto rounded">
                            </div>
                          </div>
                          <h6 class="fw-medium w-100 text-truncate text-center">{{ item.name }}</h6>
                        </div>
                      </div>
                    </a>
              
                  </div>
                </div>
              </div> -->

            </div>
            <!-- <div class="col-lg-4 col-md-4 col-6" *ngFor="let item of services" (click)="goPage(item)">
              <div *ngIf="item.status ==1" class="card bg-light-primary card-tiny-line-stats border justify-center align-center cursor-pointer rounded">
                <div class="card-body">
                  <div class="avatar-content align-center">
                    <img src="assets/images/icons/rocket.svg" alt="Rocket svg" />
                  </div>
                  <h5>{{ item.name }}</h5>
                </div>
              </div>
            </div> -->
          </div>
        </div>
        <!--/ Revenue Report Card -->
      </div>
      <div class="col-lg-4 col-12">
        <div class="row match-height">
          <!-- Earnings Chart -->
          <div class="col-lg-12 col-md-6 col-12">
            <div class="card earnings-card">
              <div class="card-body">
                <div class="row">
                  <div class="col-6">
                    <h4 class="card-title mb-1">Sales</h4>
                    <div class="font-small-2">Today</div>
                    <h5 class="mb-1">{{ data.graph_report.today_sale_amount | currency: "₦" }}</h5>
                    <p class="card-text text-muted font-small-2">
                      <span class="font-weight-bolder">{{ data.graph_report.yesterday_amount | currency: "₦" }}</span><span> yesterday.</span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!--/ Earnings Chart -->
          <!-- Earnings Chart -->
          <div class="col-lg-12 col-md-6 col-12">
            <div class="card earnings-card">
              <img width="" font-align="center" height="" src="assets/images/ad-space.png" alt="Ads Space" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row match-height">
      <!-- Company Table -->
      <div class="col-lg-12 col-12">
        <div class="card card-company-table">
          <div class="card-body p-0">
            <div class="table-responsive">
              <table class="table">
                <thead>
                  <tr>
                    <th>Customer</th>
                    <th>Description</th>
                    <th>Receiver</th>
                    <th>Reference</th>
                    <th>Amount</th>
                  </tr>
                </thead>
                <tbody *ngIf="transactions.length === 0">
                  <tr>
                    <td colspan="4">No transactions found.</td>
                  </tr>
                </tbody>
                <tbody *ngIf="transactions.length > 0">
                  <tr *ngFor="let item of transactions">
                    <td>
                      <div class="d-flex align-items-center">
                        <div class="avatar rounded">
                          <div class="avatar-content">
                            <img src="assets/images/icons/rocket.svg" alt="Rocket svg" />
                          </div>
                        </div>
                        <div>
                          <div class="font-weight-bolder">{{ item.user_id }}</div>
                          <div class="font-small-2 text-muted">Wallet ID</div>
                        </div>
                      </div>
                    </td>
                    <td>
                      <div class="d-flex align-items-center">
                        <div class="avatar bg-light-primary mr-1">
                          <div class="avatar-content">
                            <i data-feather="monitor" class="font-medium-3"></i>
                          </div>
                        </div>
                        <span>{{ item.descc }}</span>
                      </div>
                    </td>
                    <td class="text-nowrap">
                      <div class="d-flex flex-column">
                        <span class="font-weight-bolder mb-25">{{ item.send_to }}</span>
                        <span class="font-small-2 text-muted">{{ item.created_at }}</span>
                      </div>
                    </td>
                    <td>
                      {{ item.trans_id }}
                    </td>
                    <td class="text-nowrap">
                      <div class="d-flex flex-column align-items-center">
                        <div *ngIf="item.type =='fund'" class="font-weight-bolder text-success"><small>+ {{ item.amount | currency: "₦" }}</small></div>
                        <div *ngIf="item.type !=='fund'" class="font-weight-bolder text-danger"><small>- {{ item.amount | currency: "₦" }}</small></div>
                        <span *ngIf="item.status ==0">
                          <i data-feather="trending-up" class="text-warning font-medium-1"></i> Pending
                        </span>
                        <span *ngIf="item.status ==1">
                          <i data-feather="trending-up" class="text-success font-medium-1"></i> Success
                        </span>
                        <span *ngIf="item.status ==2">
                          <i data-feather="trending-down" class="text-danger font-medium-1"></i> Fail
                        </span>
                        <span *ngIf="item.status ==3">
                          <i data-feather="trending-up" class="text-primary font-medium-1"></i> Reversed
                        </span>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <!--/ Company Table -->

    </div>
  </div>
</div>
